export const THEME_MODE_STORAGE_KEY =
	'sapphire_organizer_theme_mode_preference';
export const SUPPORTED_THEME_MODES = ['light', 'dark', 'auto'];

const AUTO_DARK_START_MINUTES = 20 * 60 + 30;
const AUTO_DARK_END_MINUTES = 4 * 60;

export const normalizeThemeMode = (mode, fallback = 'light') =>
	SUPPORTED_THEME_MODES.includes(mode) ? mode : fallback;

export const isAutoDarkTime = (date = new Date()) => {
	const minutes = date.getHours() * 60 + date.getMinutes();
	return (
		minutes >= AUTO_DARK_START_MINUTES ||
		minutes < AUTO_DARK_END_MINUTES
	);
};

export const resolveThemeMode = (mode, date = new Date()) => {
	const normalizedMode = normalizeThemeMode(mode);
	return normalizedMode === 'auto'
		? isAutoDarkTime(date)
			? 'dark'
			: 'light'
		: normalizedMode;
};

export const loadThemeModePreference = (fallback = 'light') => {
	const normalizedFallback = normalizeThemeMode(fallback);
	if (typeof window === 'undefined') return normalizedFallback;

	return normalizeThemeMode(
		window.localStorage.getItem(THEME_MODE_STORAGE_KEY),
		normalizedFallback
	);
};

export const persistThemeModePreference = mode => {
	const normalizedMode = normalizeThemeMode(mode);
	if (typeof window !== 'undefined') {
		window.localStorage.setItem(THEME_MODE_STORAGE_KEY, normalizedMode);
	}
	return normalizedMode;
};
